<template>
    <article
        class="model"
        :key="model.id"
    >
       <router-link
           v-if="model.username"
           :to="{name: 'model.username', params: {username: '@'+model.username}}"
       >
            <div class="img">
                <img :src="model.public_vertical_image_path['small']">
            </div>
        </router-link>
       <router-link
           v-else
           :to="{name: 'model.profile', params: {id: model.id}}"
       >
            <div class="img">
                <img :src="model.public_vertical_image_path['small']">
            </div>
        </router-link>

        <div class="text">
            <h4 class="name">
                {{model.name}}
            </h4>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        model: {
            type: Object,
            required: true,
        }
    }
}
</script>
<style scoped lang="scss">
@import '../styles/variables';

.model{
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 10px;
    margin-top: 10px;
}

.img{
    background-color: $pallete_secondary_color;
    min-height: 100px;
    margin-bottom: .5em;

    img{
        width: 100%;
    }
}

.text{
    text-align: left;

    .description{
        margin: 0;
        color: grey;
    }

    .name{
        margin: 0;
    }
}
</style>